$(document).ready(function () {
    var swiper = new Swiper('.p-scene__slider', {
        loop: true,
        pagination: false,
        centeredSlides: true,
        speed: 500,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        slidesPerView: 2.9,
        spaceBetween: 0,
        autoplay: { delay: 3000 },
        breakpoints: {
            0: {
                slidesPerView: 1.6,
                spaceBetween: 0
            },
            768: {
                slidesPerView: 2.8,
                spaceBetween: 0
            }
        }
    });

    var swiper = new Swiper('.p-product-coordinates__swiper', {
        loop: true,
        pagination: false,
        centeredSlides: true,
        speed: 500,
        navigation: false,
        slidesPerView: 3.5,
        spaceBetween: 16,
        autoplay: { delay: 3000 },
        breakpoints: {
            0: {
                slidesPerView: 1.6,
                spaceBetween: 16
            },
            768: {
                slidesPerView: 3.5,
                spaceBetween: 16
            }
        }
    });
});
